import * as signals from "signals";

export default {
  resize: new signals.Signal (),
  uiLoadAssets: new signals.Signal (),
  loadingAssetsComplete: new signals.Signal (),
  startUI: new signals.Signal (),
  builtAll: new signals.Signal (),
  isMobileChanged: new signals.Signal (),
  orientationChanged: new signals.Signal (),
  allHide: new signals.Signal (),
  currentBetIndexHasChanged: new signals.Signal (),
  currentBuyFreebetChanged: new signals.Signal (),
  hideAutoplay: new signals.Signal (),
  betsUpdates: new signals.Signal (),
  roundEnd: new signals.Signal (),
  takeWinUpdate: new signals.Signal (),

  //BaseUIComponent events
  hideLayout: new signals.Signal (),
  showLayout: new signals.Signal (),
//  showSettings: new signals.Signal (),
  stopAutoplay: new signals.Signal (),
  startAutoplay: new signals.Signal (),
  setAutoplayStart: new signals.Signal (),

  hideComponentEverywhere: new signals.Signal (),
  showComponentEverywhere: new signals.Signal (),
  hideComponent: new signals.Signal (),
  showComponent: new signals.Signal (),
  upperComponent: new signals.Signal (),

  setStateUIButtons: new signals.Signal (),
  setStateUIPanels: new signals.Signal (),
  setFreeSpin: new signals.Signal (),
  setFreeSpinLeft: new signals.Signal (),

  //TextComponent events
  setValue: new signals.Signal (),
  setWinUI: new signals.Signal (),
  setBalance: new signals.Signal (),
  setBet: new signals.Signal (),


  //DynamicTextComponent events
  dynamicTextValueChanged: new signals.Signal (),

  //StateButtonComponent events
  setState: new signals.Signal (),
  setStateMenu: new signals.Signal (),
  setStateSettings: new signals.Signal ()
}